import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de18f456"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray-200 py-10 px-12" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-lg font-bold" }, "Find Your Bike", -1))
const _hoisted_3 = { class: "py-5 sm:px-20 sm:flex sm:flex-row items-center justify-center" }
const _hoisted_4 = { class: "w-full sm:w-2/6 p-10 sm:px-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Price ", -1))
const _hoisted_6 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_HandleBikes = _resolveComponent("HandleBikes")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterBikes && _ctx.filterBikes(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          type: "text",
          class: "mt-0 block w-full px-0.5 sm:mx-8 bg-gray-200 border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black w-full sm:w-1/3",
          placeholder: "Type your search here..."
        }, null, 512), [
          [_vModelText, _ctx.searchText]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Slider, {
            class: "slider-black",
            modelValue: _ctx.price,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.price) = $event)),
            format: {
              prefix: '€',
            },
            min: _ctx.minPrice,
            max: _ctx.maxPrice,
            merge: 10
          }, null, 8, ["modelValue", "min", "max"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterBikes && _ctx.filterBikes(...args))),
            class: "rounded bg-gray-800 px-6 py-2.5 text-xs font-medium uppercase leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-primary-700 hover:shadow-lg focus:bg-primary-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-primary-800 active:shadow-lg"
          }, " SEARCH ")
        ])
      ])
    ], 32),
    _createVNode(_component_HandleBikes, {
      bikes: _ctx.bikes,
      isLoading: _ctx.isLoading,
      onLoadMore: _ctx.onLoadMore
    }, null, 8, ["bikes", "isLoading", "onLoadMore"])
  ]))
}